import dynamic from 'next/dynamic';
import { useRouter } from "next/router";
import BreadCrumbs from "../../src/components/BreadCrumbs";
import { GameList } from "../../src/list/GameList";
import { Assets } from "../../src/list/Assets";
import { useEffect, useState, useRef } from "react";
import {Categories }from "../../src/list/PageList";
import GridLayout from '../../src/components/GridLayout.js';
import CategoryGames from '../../src/components/CategoryGames.js';
import Headcom from '../../src/components/Headcom.js';
import Ad_320x50 from '../../src/ads/Ad_320x50.js';

const FooterCom = dynamic(() => import('../../src/components/FooterCom'));
const FooterDis = dynamic(() => import('../../src/Description/FooterDis'));

const Snow_fx = dynamic(() => import('../../src/fx/Snow_fx'));
const CommenDis = dynamic(() => import('../../src/Description/CommenDis'));

const CatBtn = dynamic(() => import('../../src/components/CatBtn'));
const BlackScreen = dynamic(() => import('../../src/components/BlackScreen'));
const CookieCom = dynamic(() => import('../../src/components/CookieCom'));

const MobileExitButton = dynamic(() => import('../../src/components/MobileExitButton.js'));

const Ad_300x250_1 = dynamic(() => import('../../src/ads/Ad_300x250_1'), {
  ssr: false,
  loading: () => <p>Loading Ad...</p>,
});

const Ad_728x90_Bot = dynamic(() => import('../../src/ads/Ad_728x90_Bot'), {
  ssr: false,
  loading: () => <p>Loading Ad...</p>,
});

export async function getStaticPaths() {
  return {
    paths: GameList.map((page) => ({
      params: { id: page.name[1] },
    })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  const game = GameList.find(game => game.name[1] === params.id);
  return {
    props: {
      game, // only load this game’s data
    },
  };
}

// export async function getStaticProps({ params }) {
//   return {
//     props: {
//       GameList,
//     },
//   };
// }

export default function GameId() {
  const viewMoreUrls = {};
  for (let i = 1; i <= 2; i++) {
    viewMoreUrls[`Category ${i}`] = `/category-${i}`;
  }
  
  const path = useRouter();
  const pathName = path.query.id;
  const [isSmall, setSmall] = useState(false);
  const [mobile, setMobile] = useState(false);
  const mobileBlackScreen = useRef(null);
  const gamePage = useRef(null);
  const mobileView = useRef(null);
  const mobileIframe = useRef(null);
  const mobileMenu = useRef(null);
  const mobileCanvas = useRef(null);
  var catlink;
  var catname;

  catlink =BreadCatLink(setIframe().tag);
  catname =BreadcatName(setIframe().tag);

  useEffect(() => {
    if (typeof window !== "undefined") {
      // Set the default body style
      document.body.style.overflow = "auto";

      const handleResize = () => {
        if (
          window.innerWidth >= 747 &&
          !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          setSmall(false);
        } else {
          setSmall(true);
        }
        if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          setMobile(true);
        } else {
          setMobile(false);
        }
      };

      const handleFullscreenChange = () => {
        if (!document.fullscreenElement) {
          // Fullscreen mode has been exited
          mobileExitYes();
        }
      };

      // Add window and document event listeners
      window.addEventListener("resize", handleResize);
      document.addEventListener("fullscreenchange", handleFullscreenChange);
      document.addEventListener("webkitfullscreenchange", handleFullscreenChange); // For Safari
      document.addEventListener("mozfullscreenchange", handleFullscreenChange); // For Firefox
      document.addEventListener("MSFullscreenChange", handleFullscreenChange); // For IE/Edge

      // Handle initial resize
      handleResize();


      // Clean up event listeners on component unmount
      return () => {
        window.removeEventListener("resize", handleResize);
        document.removeEventListener("fullscreenchange", handleFullscreenChange);
        document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
        document.removeEventListener("mozfullscreenchange", handleFullscreenChange);
        document.removeEventListener("MSFullscreenChange", handleFullscreenChange);

      };
    }
  }, []);


  function Sandbox(value) {
    var sand_value;
    if (value == "") {
      // sand_value = "allow-scripts allow-popups allow-same-origin";
    } else {
      // sand_value =
        // "allow-forms allow-pointer-lock allow-popups-to-escape-sandbox allow-same-origin allow-scripts allow-top-navigation-by-user-activation";
    }
    return sand_value;
  }

  function mPlaybtn() {
    gamePage.current.setAttribute("style", "display:none");
    mobileView.current.setAttribute("style", "display:flex");
    mobileIframe.current.src = setIframe().iframe;
    // mobileIframe.current.sandbox = Sandbox(setIframe().brand);
    mobileFullscreen();
  }
  function mobileExit() {
    mobileBlackScreen.current.setAttribute("style", "display:block");
    mobileMenu.current.setAttribute("style", "display:flex");
  }

  function mobileExitNo() {
    mobileBlackScreen.current.setAttribute("style", "display:none");
    mobileMenu.current.setAttribute("style", "display:none");
  }

  function mobileExitYes() {
    mobileBlackScreen.current.setAttribute("style", "display:none");
    mobileMenu.current.setAttribute("style", "display:none");
    gamePage.current.setAttribute("style", "display:block");
    mobileView.current.setAttribute("style", "display:none");
    mobileIframe.current.src = " ";
    ExitmobileFullscreen();
  }


  function ExitmobileFullscreen() {
    if (document.fullscreenElement) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } }
  
  function mobileFullscreen() {
    if (document.fullscreenElement) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } else {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        if (mobileView.current.requestFullscreen) {
          mobileView.current.requestFullscreen({
            navigationUI: "show",
          });
        } else if (mobileView.current.webkitRequestFullscreen) {
          mobileView.current.webkitRequestFullscreen({
            navigationUI: "show",
          });
        } else if (mobileView.current.mozRequestFullScreen) {
          mobileView.current.mozRequestFullScreen({
            navigationUI: "show",
          });
        } else if (mobileView.current.msRequestFullscreen) {
          mobileView.current.msRequestFullscreen({
            navigationUI: "show",
          });
        }

        if (setIframe().orientation == 0) {
          screen.orientation
            .lock("landscape-primary")
            .then(function () {})
            .catch(function (error) {
            });
        } else {
          screen.orientation
            .lock("portrait-primary")
            .then(function () {})
            .catch(function (error) {
            });
        }
      } else {
        if (mobileView.current.requestFullscreen) {
          mobileView.current.requestFullscreen();
        } else if (mobileView.current.webkitRequestFullscreen) {
          mobileView.current.webkitRequestFullscreen();
        } else if (mobileView.current.mozRequestFullScreen) {
          mobileView.current.mozRequestFullScreen();
        } else if (mobileView.current.msRequestFullscreen) {
          mobileView.current.msRequestFullscreen();
        }
      }
    }
  }
  function setIframe() {
    var iframeUrl;
    var i;
    for (i = 0; i < GameList.length; i++) {
      if (pathName == GameList[i].name[1]) {
        iframeUrl = GameList[i];
        break;
      }
    }
    return iframeUrl;
  }

  function BreadCatLink(value){
    var link;
    var i;
    var j;
    for(j=0;j<value.length;j++){
    for(i=0;i<Categories.length;i++){
       if(Categories[i].key==value[j]){
         link= Categories[i].path[0];
         i=100; // break the loop
         j=100; // break the loop
        break;
       }
     }

     
    }

   return link;
 }

 function BreadcatName(value){
  var link;
  var i;
  var j;
  for(j=0;j<value.length;j++){
    for(i=0;i<Categories.length;i++){
       if(Categories[i].key==value[j]){
         link= Categories[i].h1;
         i=100; // break the loop
         j=100; // break the loop
         break;
       }
      
     }

     
    }
return link;
}

const first50Games = GameList.slice(0, 50);
  return (
    <>
      <Headcom
        title={setIframe().title}
        s_dis={setIframe().s_dis}
        path={setIframe().path[1] + setIframe().path[0]}
        thumb={setIframe().thumb}
        logo_16={Assets[0].logo_16}
        logo_32={Assets[0].logo_32}
        logo_192={Assets[0].logo_192}
        logo_270={Assets[0].logo_270}
        logo_512={Assets[0].logo_512}
      />
      <div className="app_cont_game">
        <div ref={mobileView} className="mobile-view">
          <div ref={mobileMenu} className="mobile-menu">
            <div className="menu-container">
              <p className="mhead">Quit Game</p>
              <p className="mhead2">Do you Really want to Exit ?</p>
              <div className="yes" onClick={mobileExitYes}>
                <p className="mText">yes</p>
              </div>
              <div className="no" onClick={mobileExitNo}>
                <p className="mText">No</p>
              </div>
            </div>
          </div>
          <div ref={mobileBlackScreen} className="mobile-black_screen"></div>
          <div ref={mobileCanvas} className="mobile-container">
          <MobileExitButton onClick={mobileExit}/>
            <iframe
              ref={mobileIframe}
              className="mobile-canvas"
              height="100%"
              width="100%"
              frameBorder="0"
              scrolling="no"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div ref={gamePage} className="game-page">
          <BlackScreen />
          <div className="game-root">
            <div className="container">
              <div className="grid-container">
              <GridLayout items={viewMoreUrls} mOncliock={mPlaybtn} />
              {mobile && <Ad_300x250_1 />} 
                 {!mobile && <CategoryGames games={first50Games}  />} 
                 {mobile && <CategoryGames games={first50Games}  />} 
                 {mobile && <Ad_320x50 />} 
              </div>
              
            </div>
          </div>
         
          {!mobile &&  <Ad_728x90_Bot />}
          {/* <CatBtn />  */}
          <BreadCrumbs  
          
          catlink={catlink}
          cat={catname}
          link={setIframe().path[0]}
          gamename={setIframe().name[0]}
          gamekey={setIframe().tag}
          />
          <CommenDis
            
            dis={setIframe().l_dis}
            tag={setIframe().tag}
            howto={setIframe().hint}
            video={setIframe().Walkthrough}
          />
        </div>
      </div>
      {/* <FooterDis /> */}
      <FooterCom />
      <Snow_fx />
      <CookieCom />
    </>
  );
}
